(() => {
  const source = document.currentScript;
  if (!source) return;

  const urls = {
    bulkJs: source.dataset.quickAddBulkJs,
    listJs: source.dataset.quickOrderListJs,
    quantityJs: source.dataset.quantityPopoverJs,
    listCss: source.dataset.quickOrderListCss,
    quantityCss: source.dataset.quantityPopoverCss,
    productFormJs: source.dataset.productFormJs,
    quickAddJs: source.dataset.quickAddJs,
    pricePerItemJs: source.dataset.pricePerItemJs,
    productCardCss: source.dataset.productCardCss,
    textAnimationJs: source.dataset.textAnimationJs
  };

  const pending = new Map();

  const loadStyle = (url, key) => {
    if (!url || document.querySelector(`link[data-ukh-optional="${key}"]`)) return;
    const alreadyLoaded = Array.from(document.querySelectorAll('link[rel="stylesheet"]')).some(link => link.href === url);
    if (alreadyLoaded) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    link.dataset.ukhOptional = key;
    document.head.appendChild(link);
  };

  const loadScript = (url, key) => {
    if (!url) return Promise.resolve();
    if (pending.has(key)) return pending.get(key);

    const existing = document.querySelector(`script[data-ukh-optional="${key}"]`);
    if (existing) return Promise.resolve();

    const promise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.async = false;
      script.dataset.ukhOptional = key;
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.body.appendChild(script);
    });

    pending.set(key, promise);
    return promise;
  };

  const loadQuantity = () => {
    loadStyle(urls.quantityCss, 'quantity-popover-css');
    if (customElements.get('quantity-popover')) return Promise.resolve();
    return loadScript(urls.quantityJs, 'quantity-popover-js');
  };

  const loadCoreCommerce = () => {
    const tasks = [];
    if (!customElements.get('product-form-component')) tasks.push(loadScript(urls.productFormJs, 'product-form-js'));
    if (!customElements.get('quick-add-modal')) tasks.push(loadScript(urls.quickAddJs, 'quick-add-js'));
    if (!customElements.get('price-per-item')) tasks.push(loadScript(urls.pricePerItemJs, 'price-per-item-js'));
    return Promise.all(tasks);
  };

  const loadBulk = () => {
    loadStyle(urls.listCss, 'quick-order-list-css');

    const bulkReady = customElements.get('quick-add-bulk')
      ? Promise.resolve()
      : loadScript(urls.bulkJs, 'quick-add-bulk-js');

    return bulkReady.then(() => {
      if (customElements.get('bulk-modal') && customElements.get('quick-order-list')) return;
      return loadScript(urls.listJs, 'quick-order-list-js');
    });
  };

  const has = (root, selector) => {
    if (!root) return false;
    if (root.matches?.(selector)) return true;
    return Boolean(root.querySelector?.(selector));
  };

  const scan = (root = document) => {
    if (has(root, '.product-card-wrapper')) {
      loadStyle(urls.productCardCss, 'product-card-css');
    }

    if (has(root, 'product-form-component, quick-add-modal, modal-opener[data-modal="#QuickAddStandard"], price-per-item')) {
      loadCoreCommerce();
    }

    if (has(root, 'quantity-popover')) loadQuantity();

    if (has(root, 'quick-add-bulk, quick-order-list, modal-opener[data-modal="#QuickAddBulk"]')) {
      loadBulk();
    }

    if (has(root, 'text-animation, .typing-text')) {
      loadScript(urls.textAnimationJs, 'text-animation-js');
    }
  };

  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:block:select', event => scan(event.target));

  window.UKHOptionalCommerceLoader = { scan };
})();
